<ng-container *transloco="let t; read: 'dod-main-content'">
  <h1 class="main-title" id="searchResults">{{ t('verified_directories') }}</h1>

  <dod-directory-toolbar />

  <div>
    <h2 class="sub-title">{{ t('title') }}</h2>
    <accredible-tabs class="region-selector">
      <accredible-tab>
        <accredible-tab-header
          [dataCy]="'tab-region-us'"
          [active]="currentRegion() === 'US'"
          (tabSelected)="onTabChange('US')">
          {{ t('north_america') }}
          @if (!loading()) {
            <accredible-chip
              class="count"
              [dataCy]="'dir-count-us'"
              [data]="directories().us.total_count.toString()"
              color="primary" />
          }
        </accredible-tab-header>

        <accredible-tab-content>
          @if (loading() || directories().us.total_count > 0) {
            <dod-directory-list [directories]="directories().us.data" [isLoading]="loading()" />
          }
        </accredible-tab-content>
      </accredible-tab>

      <accredible-tab>
        <accredible-tab-header
          [dataCy]="'tab-region-eu'"
          [active]="currentRegion() === 'EU'"
          (tabSelected)="onTabChange('EU')">
          {{ t('europe') }}
          @if (!loading()) {
            <accredible-chip
              class="count"
              [dataCy]="'dir-count-eu'"
              [data]="directories().eu.total_count.toString()"
              color="primary" />
          }
        </accredible-tab-header>

        <accredible-tab-content>
          @if (loading() || directories().eu.total_count > 0) {
            <dod-directory-list [directories]="directories().eu.data" [isLoading]="loading()" />
          }
        </accredible-tab-content>
      </accredible-tab>
    </accredible-tabs>
  </div>

  @if (!noResults()) {
    <accredible-pagination
      [useCustomViewingFromTo]="true"
      [pageMeta]="currentRegionMetadata()"
      (pageChange)="onPageChange($event)" />

    <ng-container viewingFromTo />
  }

  @if (noResults()) {
    <dod-directory-list-no-results (onFiltersCleared)="handleFiltersCleared()" />
  }
</ng-container>
